/**
 * Format monétaire belge — miroir de la fonction Python `format_currency_be`.
 * Exemple : 1234.56 → "1 234,56 €" (avec U+00A0 espaces insécables).
 *
 * Utilisation :
 *   import { formatCurrencyBE } from "@/lib/currency";
 *   formatCurrencyBE(1234.56);
 */
export function formatCurrencyBE(amount) {
  const nbsp = "\u00A0";
  const n = Number(amount || 0);
  const negative = n < 0;
  const abs = Math.abs(Math.round(n * 100)) / 100;
  const intPart = Math.floor(abs);
  const decPart = Math.round((abs - intPart) * 100);
  const groups = [];
  let s = String(intPart);
  while (s.length > 3) {
    groups.unshift(s.slice(-3));
    s = s.slice(0, -3);
  }
  groups.unshift(s);
  const intStr = groups.join(nbsp);
  const decStr = String(decPart).padStart(2, "0");
  const result = `${intStr},${decStr}${nbsp}€`;
  return negative ? `-${result}` : result;
}
